module.exports = __webpack_public_path__ + "static/media/41.1205cbaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/41.jpg
// module id = 731
// module chunks = 0